import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);

export const useSite = () => useContext(SiteContext);

export function SiteProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ct-lang") || "en");
  const [content, setContent] = useState(null);

  const loadContent = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent(data && data.site_name ? data : null);
    } catch (e) {
      console.error("content load failed", e);
      setContent(null);
    }
  }, []);

  useEffect(() => {
    loadContent();
  }, [loadContent]);

  useEffect(() => {
    localStorage.setItem("ct-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  // t({en, es}) -> localized string
  const t = useCallback(
    (obj) => {
      if (obj == null) return "";
      if (typeof obj !== "object") return String(obj);
      return obj[lang] ?? obj.en ?? Object.values(obj)[0] ?? "";
    },
    [lang]
  );

  const toggleLang = useCallback(() => setLang((l) => (l === "en" ? "es" : "en")), []);

  return (
    <SiteContext.Provider value={{ lang, setLang, toggleLang, t, content, reloadContent: loadContent }}>
      {children}
    </SiteContext.Provider>
  );
}
